<div class="container" >
    <div class="noPrint">
    <form role="form" [formGroup]="selctform" (submit)="OnResultSubmit()">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                <input id="seat"  formControlName="seat"  placeholder="seat"  class="form-control" type="text" value=""  >
                    
                </div>
                
            </div>
            

            <div class="col-md-6" style="margin-top:-25px;">
                <div class="form-group">
                    <button type="submit" class="btn btn-primary my-4" >Get Result</button>   
                </div>
            
            </div>
        </div>
        
    </form>
</div>
<div class="book">
    <div class="page">
        <div class="subpage" style ="background-image: url('assets/result1.jpg');">
            <table class="heading">
                <tr>
                    <th style="font-size: 26px;">Name : {{stname}}</th>
                    
                </tr>
               
              </table>
              <table class="headerclass" >
                
               <tr>
                    <td style="width: 152px;">{{exam}}</td>
                    <td>12345601110</td>
                    <td style="width: 136px;">{{seat}}</td>
                    <td>{{scode}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;{{centre}}</td>
                </tr>
              </table>
              
              <table class="subjectmarks">
                
               <tr>
                    <td style="width: 301px;">{{s1name}}</td>
                    <td>{{s1thext}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{s1thint}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{sb1tgr}}&nbsp;&nbsp;&nbsp;</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb1p}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb1pit}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{sb1pgr}}&nbsp;&nbsp;</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb1x}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb1gr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; A</td>
                </tr>
                  <tr>
                    <td style="width: 301px;">{{s2name}} </td>
                    
                    <td>{{s2thext}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{s2thint}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{sb2tgr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb2p}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb2pit}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{sb2pgr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb2x}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb2gr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; A</td>
                </tr>
                 <tr>
                    <td style="width: 301px;">{{s3name}}</td>
                  
                    <td>{{s3thext}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{s3thint}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{sb3tgr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb3p}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb3pit}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{sb3pgr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb3x}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb3gr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; A</td>
                </tr>
                <tr>
                    <td style="width: 301px;">{{s4name}}</td>
                    <td>{{s4thext}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{s4thint}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{sb4tgr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb4p}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb4pit}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{sb4pgr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb4x}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb4gr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; A</td>
                </tr>
                <tr>
                    <td style="width: 301px;">{{s5name}}</td>
                    <td>{{s5thext}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{s5thint}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{sb5tgr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb5p}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb5pit}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{sb5pgr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb5x}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb5gr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; A</td>
                </tr>
                <tr>
                    <td style="width: 301px;">{{s6name}}</td>
                    <td>{{s6thext}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{s6thint}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{sb6tgr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb6p}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb6pit}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{sb6pgr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb6x}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb6gr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; A</td>
                </tr>
                <tr>
                    <td style="width: 301px;">{{s7name}}</td>
                    <td>{{s7thext}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{s7thint}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{sb7tgr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb7p}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb7pit}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{sb7pgr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb7x}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{sb7gr}}</td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </td>
                </tr>
              </table>
              
        </div>  
        <button onclick="window.print()" class="btn btn-primary noPrint" type="submit">Print</button> 
    </div>
 </div>
</div>

  
    